import {useQuery} from '@tanstack/react-query';
import {useAxios} from '../../hooks/axios/useAxios';
import {acknowledgementInfoUrl} from "../../constants/api/soft-user/endpoints";


export const useQueryAcknowledgementInfo = () => {
  const axios = useAxios();

  const handleRequest = () => {
    return axios.get(acknowledgementInfoUrl,
      {
        params: {
          tag: "start_application",
        }
      })
      .then(response => response?.data ?? response);
  };

  return useQuery({
    queryKey: ['acknowledgement-info'],
    queryFn: handleRequest
  })
};
